export enum TiposDeControleDeCarregamento {
  Inativo,
  Iniciado,
  Concluido
}
